import React from 'react';
import { FaArrowLeft, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';

const CertificateClientMoney = ({ setCurrentView }) => {
  return (
    <div className="certificate-container">
      <div className="certificate-header">
        <button className="certificate-back-btn" onClick={() => setCurrentView('main')}>
          <FaArrowLeft /> Back
        </button>
        <h4>Treasury Shield</h4>
      </div>

      <div className="certificate-content">
        <div className="certificate-card">
          <div className="certificate-icon">
            <FaShieldAlt className="shield-icon" />
          </div>
          <h3>Guardian of Prosperity</h3>
          <div className="certificate-image">
            <img src="/client_money_protection.PNG" alt="Vision Tech Certificate" className="cert-img" />
          </div>
          <div className="certificate-verification">
            <FaCheckCircle className="verify-icon" />
            <span>Trust Certified</span>
          </div>
        </div>

        <div className="company-description">
          <h4>Vision Tech's Promise</h4>
          <div className="description-content">
            <p>
              In Kenya's heart, where innovation starts,
              Vision Tech plays its vital parts.
              From Silicon Valley to African shore,
              Bringing tech solutions, and so much more.
            </p>
            <p>
              Your funds we guard with utmost care,
              Protected by laws both firm and fair.
              The bank keeps watch each day,
              Ensuring your wealth is safe to stay.
            </p>
            <div className="compliance-points">
              <div className="compliance-item">
                <FaCheckCircle className="check-icon" />
                <span>Registered and True</span>
              </div>
              <div className="compliance-item">
                <FaCheckCircle className="check-icon" />
                <span>Verified Through and Through</span>
              </div>
              <div className="compliance-item">
                <FaCheckCircle className="check-icon" />
                <span>Your Gateway to Growth</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateClientMoney;